// Angular imports
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { PercentPipe } from '@angular/common';

// Cell base class
import { CellComponent } from '../cell.component';

// Define types
type TextAlign = 'left' | 'center' | 'right';
type FontWeight = 'normal' | 'bold' | 'bolder' | 'lighter' | number;

@Component({
    selector: 'text-cell',
    templateUrl: './text-cell.component.html',
    styleUrls: ['./text-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [PercentPipe],
    standalone: false
})
export class TextCellComponent extends CellComponent<string | undefined> implements OnInit {
    @Input() public textAlign: TextAlign = 'left';
    @Input() public fontWeight: FontWeight = 'normal';
    @Input() public fontSize: string = 'inherit';

    public focus(shallow?: boolean): void {
        // Cannot focus, do nothing
    }

    public blur(): void {
        // Cannot blur, do nothing
    }

    public select(setOrigin: boolean = false): void {
        // If already selected, return
        if (this.isSelected) return;

        // Emit selection changed event
        this.selectionChange.emit({
            origin: setOrigin ? this.selection.origin ?? this.selection.current : undefined,
            current: { row: this.rowIndex, column: this.column.index } 
        });
    }

    public selectContent(): void {
       // Cannot select content, do nothing
    }

    /* --- Event handlers --- */

    // Handle click event
    public _handleClick(event: MouseEvent) {
        // Prevent default
        event.preventDefault();

        // Check if this cell is currently not selected
        if (!this.isSelected) {
            // Blur the content
            this.blur();

            // Select the cell
            return this.select(event.shiftKey);
        }
    }
}
